import React, { useState, useEffect, useCallback } from "react";
import allTeams from "../../data/teams"; // Adjust the import path as necessary
import PlayerCard from "../playerCard/PlayerCard"; // Adjust the import path as necessary
import { Link } from "react-router-dom";
import apiUrl from "../../config";
import lineup from "../../data/lineup";

const TeamDisplay = ({
  selectedTeam,
  onTotalPointsUpdate,
  seasonYears,
  injuries,
}) => {
  const [seasonSelected, setSeasonYears] = useState(seasonYears);
  const [loading, setLoading] = useState(true);
  const [lineupTeam, setLineupTeam] = useState(lineup);
  const [teams, setTeams] = useState(allTeams);
  const [rosters, setRosters] = useState([]);
  const [forwards, setForwards] = useState([]);
  const [defensemen, setDefensemen] = useState([]);
  const [goalies, setGoalies] = useState([]);
  const [colorsTeam, setColorsTeam] = useState(selectedTeam.colors);
  const [nameTeam, setNameTeam] = useState(""); // State to hold the selected team's full name]
  const [combinedRoster, setCombinedRoster] = useState([]);
  const [totalPointsTeam, setTotalPointsTeam] = useState(0);

  function slugifyTeamName(fullName) {
    return fullName
      .normalize("NFD") // Decompose accented characters
      .replace(/[\u0300-\u036f]/g, "") // Remove diacritics
      .toLowerCase()
      .replace(/\s+/g, "-") // Replace spaces with dashes
      .replace(/[^\w-]/g, ""); // Remove non-word characters
  }

  const teamSlug = slugifyTeamName(selectedTeam?.fullName);
  const teamLineupFullName = lineup[teamSlug];
  const teamLineup = abbreviateLineupNames({ [teamSlug]: teamLineupFullName })[
    teamSlug
  ];
  function normalizeName(name) {
    return name
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[^a-z\s]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function sortByLineup(data, lineupLine) {
    const normalizedLineup = lineupLine.map(normalizeName);
    return data.slice().sort((a, b) => {
      const aFullName = normalizeName(
        `${a.firstName.default[0]} ${a.lastName.default}`,
      );
      const bFullName = normalizeName(
        `${b.firstName.default[0]} ${b.lastName.default}`,
      );
      const aIndex = normalizedLineup.indexOf(aFullName);
      const bIndex = normalizedLineup.indexOf(bFullName);
      console.log(aFullName, bFullName, aIndex, bIndex);
      // If not found, assign Infinity so they go to the end
      return (
        (aIndex === -1 ? Infinity : aIndex) -
        (bIndex === -1 ? Infinity : bIndex)
      );
    });
  }

  const fetchTeams = async (team) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/teams/roster/${team}/${seasonYears}`,
      ); // Adjust the endpoint as necessary
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      } // Replace with the actual API URL
      const data = await response.json();
      setRosters(data);
      setForwards(data.forwards);
      setGoalies(data.goalies);
      setDefensemen(data.defensemen);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching teams:", error);
      setRosters([]);
      setLoading(false);
    }
  };

  function abbreviateLineupNames(lineup) {
    const newLineup = {};

    for (const team in lineup) {
      newLineup[team] = {};
      for (const position in lineup[team]) {
        newLineup[team][position] = {};
        for (const line in lineup[team][position]) {
          newLineup[team][position][line] = lineup[team][position][line].map(
            (fullName) => {
              const [firstName, ...lastNameParts] = fullName.split(" ");
              const lastName = lastNameParts.join(" ");
              return `${firstName[0]} ${lastName}`;
            },
          );
        }
      }
    }
    return newLineup;
  }

  const updatePlayerPoints = useCallback((playerId, points, goals) => {
    setCombinedRoster((prevRoster) => {
      // Check if the player already exists in the roster
      const existingPlayerIndex = (prevRoster || []).findIndex(
        (player) => player.id === playerId,
      );

      let updatedRoster;
      if (existingPlayerIndex !== -1) {
        // Update the existing player's points
        updatedRoster = [...prevRoster];
        updatedRoster[existingPlayerIndex] = {
          ...updatedRoster[existingPlayerIndex],
          points: updatedRoster[existingPlayerIndex].points + points,
          goals: updatedRoster[existingPlayerIndex].goals + goals,
        };
      } else {
        // Add a new player to the roster
        updatedRoster = [...prevRoster, { id: playerId, points, goals }];
      }
      // Calculate the total points
      const total = updatedRoster.reduce(
        (sum, player) => sum + player.points,
        0,
      );
      setTotalPointsTeam(total);
      //onTotalPointsUpdate(total);

      return updatedRoster;
    });
  }, []);

  useEffect(() => {
    fetchTeams(selectedTeam.rawTricode);
  }, [selectedTeam]);

  useEffect(() => {
    const combined = [
      ...forwards.map((player) => ({ id: player.id, points: 0, goals: 0 })),
      ...defensemen.map((player) => ({ id: player.id, points: 0, goals: 0 })),
      ...goalies.map((player) => ({ id: player.id, points: 0, goals: 0 })),
    ];
    setCombinedRoster(combined);
  }, [forwards, defensemen, goalies]);

  useEffect(() => {
    onTotalPointsUpdate(totalPointsTeam);
  }, [onTotalPointsUpdate, totalPointsTeam]);

  const playerWithMostGoals = combinedRoster.reduce(
    (max, player) => (player.goals > (max.goals || 0) ? player : max),
    {},
  );
  const playerWithMostPoints = combinedRoster.reduce(
    (max, player) => (player.points > (max.points || 0) ? player : max),
    {},
  );

  function normalizeName(name) {
    // Remove diacritics
    return name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  return (
    <div className="teamContent">
      <h2>ROSTER</h2>
      <div className="title">Forwards</div>
      <div className="team-roster">
        {Array.isArray(forwards) ? (
          (() => {
            const sortedForwards = sortByLineup(
              forwards,
              teamLineup.forwards.line1.concat(
                teamLineup.forwards.line2,
                teamLineup.forwards.line3,
                teamLineup.forwards.line4,
              ),
            );
            const groups = [];
            for (let i = 0; i < sortedForwards.length; i += 3) {
              groups.push(sortedForwards.slice(i, i + 3));
            }
            return groups.map((group, groupIdx) => (
              <div className="row" key={`def-row-${groupIdx}`}>
                {group.map((player) => {
                  let injurieStatus = injuries.some(
                    (injuredPlayer) =>
                      injuredPlayer.name ===
                      normalizeName(
                        player.firstName.default.trim() +
                          " " +
                          player.lastName.default.trim(),
                      ),
                  );

                  const allForwards = teamLineup.forwards.line1.concat(
                    teamLineup.forwards.line2,
                    teamLineup.forwards.line3,
                    teamLineup.forwards.line4,
                  );

                  let scratchedStatus = allForwards.some(
                    (scratchedPlayerName) =>
                      scratchedPlayerName ===
                      normalizeName(
                        player.firstName.default[0] +
                          " " +
                          player.lastName.default,
                      ),
                  );

                  return (
                    <PlayerCard
                      scratchedStatus={scratchedStatus}
                      injurieStatus={injurieStatus}
                      mostGoals={player.id === playerWithMostGoals.id}
                      mostPoints={player.id === playerWithMostPoints.id}
                      player={player}
                      key={player.id}
                      colors={selectedTeam.colors}
                      team={selectedTeam}
                      updatePlayerPoints={updatePlayerPoints}
                    />
                  );
                })}
              </div>
            ));
          })()
        ) : (
          <p>No rosters available</p>
        )}
      </div>
      <div className="title">Defenseman</div>
      <div className="team-roster">
        {Array.isArray(defensemen) ? (
          (() => {
            const sortedDefensemen = sortByLineup(
              defensemen,
              teamLineup.defense.line1.concat(
                teamLineup.defense.line2,
                teamLineup.defense.line3,
              ),
            );
            const groups = [];
            for (let i = 0; i < sortedDefensemen.length; i += 2) {
              groups.push(sortedDefensemen.slice(i, i + 2));
            }

            return groups.map((group, groupIdx) => (
              <div className="row" key={`def-row-${groupIdx}`}>
                {group.map((player) => {
                  let injurieStatus = injuries.some(
                    (injuredPlayer) =>
                      injuredPlayer.name ===
                      normalizeName(
                        player.firstName.default.trim() +
                          " " +
                          player.lastName.default.trim(),
                      ),
                  );

                  const alldefense = teamLineup.defense.line1.concat(
                    teamLineup.defense.line2,
                    teamLineup.defense.line3,
                    teamLineup.defense.line4,
                  );

                  let scratchedStatus = alldefense.some(
                    (scratchedPlayerName) =>
                      scratchedPlayerName ===
                      normalizeName(
                        player.firstName.default[0] +
                          " " +
                          player.lastName.default,
                      ),
                  );

                  return (
                    <PlayerCard
                      scratchedStatus={scratchedStatus}
                      injurieStatus={injurieStatus}
                      mostGoals={player.id === playerWithMostGoals.id}
                      mostPoints={player.id === playerWithMostPoints.id}
                      player={player}
                      key={player.id}
                      colors={selectedTeam.colors}
                      team={selectedTeam}
                      updatePlayerPoints={updatePlayerPoints}
                    />
                  );
                })}
              </div>
            ));
          })()
        ) : (
          <p>No rosters available</p>
        )}
      </div>
      <div className="title">Goalie</div>
      <div className="team-roster">
        {Array.isArray(goalies) ? (
          (() => {
            const sortedGoalies = sortByLineup(
              goalies,
              teamLineup.goalies.line1,
            );
            const groups = [];
            for (let i = 0; i < sortedGoalies.length; i += 2) {
              groups.push(sortedGoalies.slice(i, i + 2));
            }

            return groups.map((group, groupIdx) => (
              <div className="row" key={`def-row-${groupIdx}`}>
                {group.map((player) => {
                  let injurieStatus = injuries.some(
                    (injuredPlayer) =>
                      injuredPlayer.name ===
                      normalizeName(
                        player.firstName.default.trim() +
                          " " +
                          player.lastName.default.trim(),
                      ),
                  );

                  const allGoalies = teamLineup.goalies.line1;

                  let scratchedStatus = allGoalies.some(
                    (scratchedPlayerName) =>
                      scratchedPlayerName ===
                      normalizeName(
                        player.firstName.default[0] +
                          " " +
                          player.lastName.default,
                      ),
                  );

                  return (
                    <PlayerCard
                      scratchedStatus={scratchedStatus}
                      injurieStatus={injurieStatus}
                      mostGoals={player.id === playerWithMostGoals.id}
                      mostPoints={player.id === playerWithMostPoints.id}
                      player={player}
                      key={player.id}
                      colors={selectedTeam.colors}
                      team={selectedTeam}
                      updatePlayerPoints={updatePlayerPoints}
                    />
                  );
                })}
              </div>
            ));
          })()
        ) : (
          <p>No rosters available</p>
        )}
      </div>
    </div>
  );
};

export default TeamDisplay;
